import * as Actions from 'src/_actions/cui'
import initialState from 'src/_store/initialState'

const mobileStatusReducer = (state = initialState.mobile_status, action) => {
  switch (action.type) {
    case Actions.SET_MOBILE_STATUS:
      return Object.assign({}, state, {
        is_mobile: action.payload.is_mobile,
        is_portrait: action.payload.is_portrait,
      })
    default:
      return state
  }
}
export default mobileStatusReducer
